export const parseEnum = <T>(
  type: T,
  value: string,
): T[keyof T] | undefined => {
  return type[value as keyof T]
}
